export default __webpack_public_path__ + "static/media/flatcar.aa3527f7.svg";